<template>
  <div class="text-center">
    <v-menu offset-y absolute v-model="lmenu" :close-on-content-click="false" :full-width="true">
      <v-btn :depressed="true" slot="activator" block>
        <span v-if="totalVehicles === 0 && !checkbox" class="caption">Click here to add number of Vehicles</span>
        <span v-if="totalVehicles >= 1" class="caption">{{totalVehicles}} Vehicle{{totalVehicles > 1 ? 's' : ''}}</span>
        <span v-if="totalVehicles === 0 && checkbox" class="caption">Vehicle Fee Booked Separately ✓</span>
      </v-btn>
      <v-list>
        <v-list-tile row v-for="(vehicles, key) in allVehicles" :key="key" :disabled="$vehicleDisabled">
          <v-container>
            <v-layout row>
              <v-flex md6 sm6 xs6 align-center>
                <p class="body-2">{{vehicles.vehicle_charge_category}} ({{vehicles.vehicle_charge_cost_currency}} {{vehicles.vehicle_charge_category_cost}})</p>
              </v-flex>
              <v-flex lg2 md2 sm2 xs2 align-center>
                <v-btn-toggle>
                  <v-btn :depressed="true" @click="reduceVehicles(key)" round small color="error"><v-icon>remove</v-icon></v-btn>
                </v-btn-toggle>
              </v-flex>
              <v-flex lg2 md2 sm2 xs2 align-center>
                <h4 class="text-md-center text-sm-center text-xs-center">{{allVehicles[key].vehicles}}</h4>
              </v-flex>
              <v-flex lg2 md2 sm2 xs2 align-center>
                <v-btn-toggle>
                  <v-btn :depressed="true" @click="addVehicles(key)" small color="primary"><v-icon>add</v-icon></v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
        </v-list-tile>
        <v-list-tile>
          <v-container>
            <v-checkbox v-model="checkbox"
                        @change="updateVehicles()"
                        label="Vehicle fee already booked separately."
                        :persistent-hint="true"
                        color="primary"></v-checkbox>
          </v-container>
        </v-list-tile>
        <br>
        <v-list-tile>
          <v-layout row wrap>
            <v-flex md4 lg4 sm4 xs12 offset-lg7 offset-md7 offset-sm7 align-center>
              <v-btn :depressed="true" dark small block color="primary" @click="closeMenu">Close</v-btn>
            </v-flex>
          </v-layout>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  export default {
    name: 'vehicle',
    data() {
      return {
        lmenu: false,
        checkbox: false,
        allVehicles: []
      }
    },
    computed: {
      totalVehicles() {
        if (!this.allVehicles || this.allVehicles.length === 0) return 0
        return this.allVehicles.reduce((total, vehicle) => {
          return total + (Number(vehicle.vehicles) || 0)
        }, 0)
      },
      
      globalVehicles() {
        if (this.$store.state.GlobalBookingStore && this.$store.state.GlobalBookingStore.booking_vehicles) {
          return this.$store.state.GlobalBookingStore.booking_vehicles
        }
        return { total: 0, vehicles: [] }
      }
    },
    created() {
      this.initializeVehicles()
      // Load checkbox state from localStorage
      const vehicleSeparate = localStorage.getItem('vehicle_separate')
      if (vehicleSeparate !== null) {
        this.checkbox = JSON.parse(vehicleSeparate)
      }
    },
    methods: {
      initializeVehicles() {
        const vehicleData = localStorage.getItem('vehicle_data')
        if (vehicleData && JSON.parse(vehicleData).length !== 0) {
          this.allVehicles = JSON.parse(vehicleData)
          if (this.$store.commit) {
            this.$store.commit('LOCAL_VEHICLES', this.allVehicles)
          }
        } 
        else if (this.$store.state.VehicleFeeStore && 
                 this.$store.state.VehicleFeeStore.all_vehicle_fees && 
                 this.$store.state.VehicleFeeStore.all_vehicle_fees.length > 0) {
          this.allVehicles = JSON.parse(JSON.stringify(this.$store.state.VehicleFeeStore.all_vehicle_fees))
          this.allVehicles.forEach(function(vehicle) {
            if (!vehicle.vehicles) vehicle.vehicles = 0
          })
        }
        else if (this.globalVehicles && this.globalVehicles.total > 0) {
          this.restoreVehiclesFromGlobalStore()
        }
        else {
          this.fetchVehicleFees()
        }
        
        // Check if vehicle fee already booked separately from store
        if (this.$store.state && this.$store.state.VEHICLE_SEPARATE !== undefined) {
          this.checkbox = this.$store.state.VEHICLE_SEPARATE
        }
        
        // Also check localStorage for backup
        const vehicleSeparate = localStorage.getItem('vehicle_separate')
        if (vehicleSeparate !== null) {
          this.checkbox = JSON.parse(vehicleSeparate)
        }
      },
      
      fetchVehicleFees() {
        var self = this
        this.$store.dispatch('get_all_vehicle_fees')
          .then(function(response) {
            if (response && response.data) {
              self.allVehicles = JSON.parse(JSON.stringify(response.data))
              self.allVehicles.forEach(function(vehicle) {
                if (!vehicle.vehicles) vehicle.vehicles = 0
              })
            } else if (self.$store.state.VehicleFeeStore && 
                       self.$store.state.VehicleFeeStore.all_vehicle_fees) {
              self.allVehicles = JSON.parse(JSON.stringify(self.$store.state.VehicleFeeStore.all_vehicle_fees))
              self.allVehicles.forEach(function(vehicle) {
                if (!vehicle.vehicles) vehicle.vehicles = 0
              })
            }
          })
          .catch(function(error) {
            console.error('Error fetching vehicle fees:', error)
          })
      },
      
      restoreVehiclesFromGlobalStore() {
        var self = this
        if (this.allVehicles && this.allVehicles.length > 0 && this.globalVehicles.vehicles) {
          this.allVehicles.forEach(function(vehicle, index) {
            if (self.globalVehicles.vehicles[index]) {
              vehicle.vehicles = self.globalVehicles.vehicles[index].vehicles || 0
            }
          })
        }
      },
      
      updateVehicles() {
        // Update store
        if (this.checkbox === true) {
          this.$store.commit('VEHICLE_SEPARATE', true)
          // Set all vehicles to 0 when checkbox is checked
          this.allVehicles.forEach(function(vehicle) {
            vehicle.vehicles = 0
          })
          this.$store.commit('DISABLED_STATUS', true)
        } else {
          this.$store.commit('VEHICLE_SEPARATE', false)
          this.$store.commit('DISABLED_STATUS', false)
        }
        
        // Save to localStorage
        localStorage.setItem('vehicle_separate', JSON.stringify(this.checkbox))
        
        // Auto-save when checkbox changes
        this.autoSaveVehicles()
      },
      
      reduceVehicles: function (key) {
        // If checkbox is checked, uncheck it when user tries to add vehicles
        if (this.checkbox) {
          this.checkbox = false
          this.$store.commit('VEHICLE_SEPARATE', false)
          this.$store.commit('DISABLED_STATUS', false)
          localStorage.setItem('vehicle_separate', JSON.stringify(false))
        }
        
        if (this.allVehicles[key] && this.allVehicles[key].vehicles > 0) {
          var vehicles = Number(this.allVehicles[key].vehicles) - 1
          this.$set(this.allVehicles[key], 'vehicles', vehicles)
          // Auto-save after change
          this.autoSaveVehicles()
        }
      },
      
      addVehicles: function (key) {
        // If checkbox is checked, uncheck it when user tries to add vehicles
        if (this.checkbox) {
          this.checkbox = false
          this.$store.commit('VEHICLE_SEPARATE', false)
          this.$store.commit('DISABLED_STATUS', false)
          localStorage.setItem('vehicle_separate', JSON.stringify(false))
        }
        
        if (this.allVehicles[key]) {
          var vehicles = Number(this.allVehicles[key].vehicles) + 1
          this.$set(this.allVehicles[key], 'vehicles', vehicles)
          // Auto-save after change
          this.autoSaveVehicles()
        }
      },
      
      // Auto-save without needing Apply button
      autoSaveVehicles() {
        // Save to localStorage
        localStorage.setItem('vehicle_data', JSON.stringify(this.allVehicles))
        
        // Update Vuex store
        if (this.$store.commit) {
          this.$store.commit('LOCAL_VEHICLES', this.allVehicles)
        }
        
        // Calculate total vehicles
        var totalVehicles = this.totalVehicles
        
        var vehiclesData = {
          total: totalVehicles,
          vehicles: this.allVehicles,
          vehicleFeeSeparate: this.checkbox // Include checkbox state
        }
        
        // Save to GlobalBookingStore if available
        if (this.$store.dispatch && this.$store.state.GlobalBookingStore) {
          this.$store.dispatch('GlobalBookingStore/updateBookingVehicles', vehiclesData)
        }
        
        // Emit event for other components - include checkbox state
        this.$emit('vehicles-auto-updated', vehiclesData)
        
        // Trigger global cart update
        this.$root.$emit('cart-updated')
      },
      
      // Close menu without applying (already auto-applied)
      closeMenu() {
        this.lmenu = false
      }
    },
    watch: {
      '$store.state.VehicleFeeStore.all_vehicle_fees': {
        handler: function(newFees) {
          if (newFees && newFees.length > 0 && this.allVehicles.length === 0) {
            this.allVehicles = JSON.parse(JSON.stringify(newFees))
            this.allVehicles.forEach(function(vehicle) {
              if (!vehicle.vehicles) vehicle.vehicles = 0
            })
          }
        },
        deep: true,
        immediate: false
      }
    }
  }
</script>

<style scoped>
</style>
